import React, { useEffect, useState } from "react";
import "./BanquetOptions.css";
import { useDispatch, useSelector } from "react-redux";
import { setmeals, setprivate, setwedding } from ".././../redux/slices/Time";
import axios from "axios";
import {
  setlinkedMeetings,
  setlinkedMeetingsLogout,
} from "../../redux/slices/LinkMeetings";
import Modal from "@mui/material/Modal";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Card,
  CardContent,
  Typography,
  Box,
} from "@mui/material";

const BanquetOptions = ({
  editmeeting,
  useTemplate,
  useTemplateSelected,
  setUseTemplateSelected,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const options = ["Breakfast", "Lunch", "High Tea", "Dinner"];
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [weddingevent, setweddingevent] = useState(false);
  const [privateevent, setprivateevent] = useState(false);
  const [allmeal, setallmeal] = useState(false);
  const dispatch = useDispatch();
  const headers = useSelector((state) => state?.header);
  const meetingObject = JSON.parse(localStorage.getItem("meetingObject"));
  const emmsheaders = useSelector((state) => state?.emmsheader);
  const curremms = useSelector((state) => state?.curremms);
  const [linkedMeetingsList, setLinkedMeetingsList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false); 

  const linkedMeeting = useSelector(
    (state) => state?.linkedmeetings?.linkedMeetingSelected
  );

  const handlefetchlinkedevents = async () => {
    if (meetingObject.user == null) {
    
      toast.error("No meetings to link", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } else {
      if (meetingObject?.user) {
        const api = localStorage.getItem("api");

        const requestBody = {
          path: "meeting/getlinkedmeetings",
          query: {
            host: `${meetingObject?.host}`,
          },
          emmsId: `${curremms.curremms.id}`,
          requestType: "GET",
          headers: {
            ...emmsheaders?.emmsheaders?.headers,
          },
        };

        axios
          .post(api + "/emms/piggyback", requestBody, headers)
          .then((data) => {
            if (data.data.length > 0) {
              setLinkedMeetingsList(data.data);

              dispatch(setlinkedMeetings(data.data));
              setModalOpen(true);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    }
  };

  const handleremovelinkedevents = () => {
    dispatch(setlinkedMeetingsLogout());
  };
  const handleSelectMeeting = (meeting) => {
   
    const meetingObject = JSON.parse(localStorage.getItem("meetingObject"));
    meetingObject.customProperties = {
      ...meetingObject.customProperties,
      meals: selectedOptions,
      weddingevent: weddingevent,
      privateevent: privateevent,
      linkedeventId:
        meeting?.customProperties?.linkedeventId != null &&
        meeting?.customProperties?.linkedeventId.length > 0
          ? meeting?.customProperties?.linkedeventId
          : meeting?.customProperties?.linkageId || null,
    };
    localStorage.setItem("meetingObject", JSON.stringify(meetingObject));
    setModalOpen(false);
  };
  useEffect(() => {
    if (editmeeting == true) {
  
    } else {
      setSelectedOptions([]);
      setweddingevent(false);
      setprivateevent(false);
    }
  }, [editmeeting]);
  const handleOptionClick = (optionToAdd) => {
    if (!selectedOptions.includes(optionToAdd)) {
      setSelectedOptions([...selectedOptions, optionToAdd]);
    }
    setIsOpen(false);
  };
  const dispatchmeals = () => {
    dispatch(setmeals(selectedOptions));
  };

  const saveToLocalStorage = () => {
   

    const meetingObject = JSON.parse(localStorage.getItem("meetingObject"));
    meetingObject.customProperties = {
      ...meetingObject.customProperties,
      meals: selectedOptions,
      weddingevent: weddingevent,
      privateevent: privateevent,
    };
    localStorage.setItem("meetingObject", JSON.stringify(meetingObject));
  };
  useEffect(() => {
    if (selectedOptions?.length === 4) {
      setallmeal(true);
    } else {
      setallmeal(false);
    }
    dispatchmeals();
    saveToLocalStorage();
  }, [selectedOptions, privateevent]);
  const disableoptions = (option) => {
    if (!selectedOptions.includes(option)) {
      return false;
    }
    return true;
  };
  const handleremovemeal = (optionToRemove) => {
    const updatedOptions = selectedOptions.filter(
      (option) => option !== optionToRemove
    );
    setSelectedOptions(updatedOptions);
    saveToLocalStorage();
  };
  return (
    <>
      <Box 
      className="banquetoptionscontainer"
      sx={{
        width:{
          xs:"100%",
          md:"26vw"
        },
        gap:{
          xs:1,
          md:0
        }
      }}
      >
        <div
          className={`weddingbuttonbanquetoptions ${
            weddingevent ? "selectedBanquetOptions" : ""
          }`}
          onClick={() => {
            setweddingevent(!weddingevent);
            dispatch(setwedding(!weddingevent));
          }}
        >
          Wedding
        </div>
        <div
          className={`privatemeetingbuttonbanquetoptions  ${
            privateevent ? "selectedBanquetOptions" : ""
          }`}
          onClick={() => {
            setprivateevent(!privateevent);
            dispatch(setprivate(!privateevent));
          }}
        >
          Private
        </div>
        {useTemplate ? (
          <div
            className={`privatemeetingbuttonbanquetoptions  ${
              useTemplateSelected ? "selectedBanquetOptions" : ""
            }`}
            onClick={() => {
              setUseTemplateSelected(!useTemplateSelected);
            }}
          >
            Use Templates
          </div>
        ) : (
          <></>
        )}
        {selectedOptions?.map((options) => {
          return (
            <div
              className={`privatemeetingbuttonbanquetoptions   selectedBanquetOptions`}
              onClick={() => {
                handleremovemeal(options);
              }}
            >
              {options}
            </div>
          );
        })}
      </Box>
      {allmeal ? (
        <></>
      ) : (
        <div className="">
          <div className="dropdown-container">
            <div className="selected-option" onClick={() => setIsOpen(!isOpen)}>
              Select Meals
            </div>
            {isOpen && (
              <ul className="options-list">
                {options.map((option, index) => (
                  <li
                    key={index}
                    onClick={() => handleOptionClick(option)}
                    className={disableoptions(option) ? "optiondisabled" : ""}
                  >
                    {option}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Select meeting to link: </DialogTitle>
        <DialogContent dividers>
          <Box display="flex" flexDirection="column" alignItems="center">
            {linkedMeetingsList.map((meeting, index) => (
              <Card
                key={index}
                variant="outlined"
                sx={{ width: "65%", mb: 1, p: 1, borderRadius: "10px" }} 
              >
                <CardContent>
                  <Typography variant="h6">{meeting?.name}</Typography>
                  <Typography color="textSecondary">
                    Host: {meeting?.user}
                  </Typography>
                </CardContent>
                <Box display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleSelectMeeting(meeting)}
                    sx={{ textTransform: "none" }}
                  >
                    Select
                  </Button>
                </Box>
              </Card>
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setModalOpen(false)}
            color="error"
            variant="outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {linkedMeeting != null ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              className="rightmodelsingleinputlinkmeetings"
              onClick={handleremovelinkedevents}
            >
              Remove Linked Event?
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              className="rightmodelsingleinputlinkmeetings"
              onClick={handlefetchlinkedevents}
            >
              Link Existing Event ?
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default BanquetOptions;
